// extracted by mini-css-extract-plugin
export default {"table":"CourseCalendar_table__b5XEI","dates":"CourseCalendar_dates__uU0NW"};